import { FirebaseObject } from './firebase/firebase-object';

export class ModelBase extends FirebaseObject {}



// WEBPACK FOOTER //
// /Users/JunnieJobs/git/nextstep-fe2/src/app/shared/base/model-base.ts